//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ExternalEditingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type OpenNewExternalEditingQueryParameters = {
  documentId: number ;
  editingType?: Types.ExternalEditingType | undefined ;
}

export type GetEditingDocumentLinkExternalEditingQueryParameters = {
  documentId: number ;
  editingType?: Types.ExternalEditingType | undefined ;
}

export type UpdateSingleEditingDocumentExternalEditingQueryParameters = {
  documentId: number ;
}

export type IsDocumentEditingByUserExternalEditingQueryParameters = {
  documentId: number ;
}

export function openNewUrl(documentId: number, editingType?: Types.ExternalEditingType | undefined): string {
  let url_ = getBaseUrl() + "/api/external-editing/{documentId}?";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
if (editingType === null)
    throw new Error("The parameter 'editingType' cannot be null.");
else if (editingType !== undefined)
    url_ += "editingType=" + encodeURIComponent("" + editingType) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function openNewMutationKey(documentId: number, editingType?: Types.ExternalEditingType | undefined): MutationKey {
  return trimArrayEnd([
      'ExternalEditingClient',
      'openNew',
      documentId as any,
      editingType as any,
    ]);
}

export function useOpenNewMutation<TContext>(documentId: number, editingType?: Types.ExternalEditingType | undefined, options?: Omit<UseMutationOptions<string, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, void, TContext> {
  const key = openNewMutationKey(documentId, editingType);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.openNew(documentId, editingType),
    mutationKey: key,
  });
}
  
type OpenNew__MutationParameters = OpenNewExternalEditingQueryParameters

export function useOpenNewMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<string, unknown, OpenNew__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: OpenNewExternalEditingQueryParameters}): UseMutationResult<string, unknown, OpenNew__MutationParameters, TContext> {
  const key = openNewMutationKey(options?.parameters?.documentId!, options?.parameters?.editingType!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: OpenNew__MutationParameters) => Client.openNew(data.documentId ?? options?.parameters?.documentId!, data.editingType ?? options?.parameters?.editingType!),
  mutationKey: key,
});
}
  
export function getEditingDocumentLinkUrl(documentId: number, editingType?: Types.ExternalEditingType | undefined): string {
  let url_ = getBaseUrl() + "/api/external-editing/{documentId}?";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
if (editingType === null)
    throw new Error("The parameter 'editingType' cannot be null.");
else if (editingType !== undefined)
    url_ += "editingType=" + encodeURIComponent("" + editingType) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getEditingDocumentLinkDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getGetEditingDocumentLinkDefaultOptions() {
  return getEditingDocumentLinkDefaultOptions;
};
export function setGetEditingDocumentLinkDefaultOptions(options: typeof getEditingDocumentLinkDefaultOptions) {
  getEditingDocumentLinkDefaultOptions = options;
}

export function getEditingDocumentLinkQueryKey(dto: GetEditingDocumentLinkExternalEditingQueryParameters): QueryKey;
export function getEditingDocumentLinkQueryKey(documentId: number, editingType?: Types.ExternalEditingType | undefined): QueryKey;
export function getEditingDocumentLinkQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { documentId, editingType,  } = params[0] as GetEditingDocumentLinkExternalEditingQueryParameters;

    return trimArrayEnd([
        'ExternalEditingClient',
        'getEditingDocumentLink',
        documentId as any,
        editingType as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExternalEditingClient',
        'getEditingDocumentLink',
        ...params
      ]);
  }
}
export function __getEditingDocumentLink(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getEditingDocumentLink(
      context.queryKey[2] as number,       context.queryKey[3] as Types.ExternalEditingType | undefined,axiosConfig    );
}

export function useGetEditingDocumentLinkQuery<TSelectData = string, TError = unknown>(dto: GetEditingDocumentLinkExternalEditingQueryParameters, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetEditingDocumentLinkQuery<TSelectData = string, TError = unknown>(documentId: number, editingType?: Types.ExternalEditingType | undefined, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetEditingDocumentLinkQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let documentId: any = undefined;
  let editingType: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ documentId, editingType,  } = params[0] as GetEditingDocumentLinkExternalEditingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [documentId, editingType, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getEditingDocumentLink(context, axiosConfig) : __getEditingDocumentLink,
    queryKey: getEditingDocumentLinkQueryKey(documentId, editingType),
    ...getEditingDocumentLinkDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetEditingDocumentLinkData(queryClient: QueryClient, updater: (data: string | undefined) => string, documentId: number, editingType?: Types.ExternalEditingType | undefined) {
  queryClient.setQueryData(getEditingDocumentLinkQueryKey(documentId, editingType),
    updater
  );
}

export function setGetEditingDocumentLinkDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateSingleEditingDocumentUrl(documentId: number): string {
  let url_ = getBaseUrl() + "/api/external-editing/update/{documentId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateSingleEditingDocumentMutationKey(documentId: number): MutationKey {
  return trimArrayEnd([
      'ExternalEditingClient',
      'updateSingleEditingDocument',
      documentId as any,
    ]);
}

export function useUpdateSingleEditingDocumentMutation<TContext>(documentId: number, options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentDto, unknown, void, TContext> {
  const key = updateSingleEditingDocumentMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.updateSingleEditingDocument(documentId),
    mutationKey: key,
  });
}
  
type UpdateSingleEditingDocument__MutationParameters = UpdateSingleEditingDocumentExternalEditingQueryParameters

export function useUpdateSingleEditingDocumentMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, UpdateSingleEditingDocument__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateSingleEditingDocumentExternalEditingQueryParameters}): UseMutationResult<Types.DocumentDto, unknown, UpdateSingleEditingDocument__MutationParameters, TContext> {
  const key = updateSingleEditingDocumentMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateSingleEditingDocument__MutationParameters) => Client.updateSingleEditingDocument(data.documentId ?? options?.parameters?.documentId!),
  mutationKey: key,
});
}
  
export function isDocumentEditingByUserUrl(documentId: number): string {
  let url_ = getBaseUrl() + "/api/external-editing/is-editing/{documentId}";
if (documentId === undefined || documentId === null)
  throw new Error("The parameter 'documentId' must be defined.");
url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let isDocumentEditingByUserDefaultOptions: Omit<UseQueryOptions<boolean | null, unknown, boolean | null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<boolean | null, unknown, boolean | null>, 'queryFn'>> = {
};
export function getIsDocumentEditingByUserDefaultOptions() {
  return isDocumentEditingByUserDefaultOptions;
};
export function setIsDocumentEditingByUserDefaultOptions(options: typeof isDocumentEditingByUserDefaultOptions) {
  isDocumentEditingByUserDefaultOptions = options;
}

export function isDocumentEditingByUserQueryKey(documentId: number): QueryKey;
export function isDocumentEditingByUserQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { documentId,  } = params[0] as IsDocumentEditingByUserExternalEditingQueryParameters;

    return trimArrayEnd([
        'ExternalEditingClient',
        'isDocumentEditingByUser',
        documentId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExternalEditingClient',
        'isDocumentEditingByUser',
        ...params
      ]);
  }
}
export function __isDocumentEditingByUser(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.isDocumentEditingByUser(
      context.queryKey[2] as number,axiosConfig    );
}

export function useIsDocumentEditingByUserQuery<TSelectData = boolean | null, TError = unknown>(dto: IsDocumentEditingByUserExternalEditingQueryParameters, options?: Omit<UseQueryOptions<boolean | null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useIsDocumentEditingByUserQuery<TSelectData = boolean | null, TError = unknown>(documentId: number, options?: Omit<UseQueryOptions<boolean | null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useIsDocumentEditingByUserQuery<TSelectData = boolean | null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<boolean | null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let documentId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ documentId,  } = params[0] as IsDocumentEditingByUserExternalEditingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [documentId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<boolean | null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __isDocumentEditingByUser(context, axiosConfig) : __isDocumentEditingByUser,
    queryKey: isDocumentEditingByUserQueryKey(documentId),
    ...isDocumentEditingByUserDefaultOptions as unknown as Omit<UseQueryOptions<boolean | null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setIsDocumentEditingByUserData(queryClient: QueryClient, updater: (data: boolean | null | undefined) => boolean | null, documentId: number) {
  queryClient.setQueryData(isDocumentEditingByUserQueryKey(documentId),
    updater
  );
}

export function setIsDocumentEditingByUserDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: boolean | null | undefined) => boolean | null) {
  queryClient.setQueryData(queryKey, updater);
}